import React from 'react'
import { Controller } from 'react-hook-form'
import { DatePicker } from 'app/components/atoms'
import { useTranslation } from 'app/i18n/client'

import { Control } from 'react-hook-form'
import { DatePickerProps } from 'app/components/atoms/DatePicker'

interface FormDatePickerProps extends DatePickerProps {
  control?: Control<any>
  name: string
  defaultValue?: Date | undefined
  error?: any
  controllerProps?: any
}

const FormDatePicker = ({
  controllerProps,
  control,
  name,
  defaultValue,
  error,
  buttonClassNames,
  ...rest
}: FormDatePickerProps) => {
  const { t } = useTranslation()

  return (
    <Controller
      control={control}
      render={({ field: { onChange, value } }) => (
        <DatePicker
          {...rest}
          buttonClassNames={buttonClassNames}
          value={value}
          onChange={onChange}
          isError={!!error}
          errorMessage={t(error?.message)}
        />
      )}
      name={name}
      defaultValue={defaultValue}
      {...controllerProps}
    />
  )
}

export default FormDatePicker
